module.exports = __webpack_public_path__ + "img/banner.ae4a8b84.png";